/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Station_Voice_Case_New_OrderInputs */

const vi_station_voice_case_new_order = /** @type {(inputs: Station_Voice_Case_New_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn mới`)
};

/**

* @param {Station_Voice_Case_New_OrderInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const station_voice_case_new_order = /** @type {((inputs?: Station_Voice_Case_New_OrderInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Station_Voice_Case_New_OrderInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_station_voice_case_new_order(inputs)
});